.add-coworkers-input-container .invitation-label {
  font-family: avenirnext-medium;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}
.add-coworkers-input-container .invitation-label .lighter {
  font-family: avenirnext-regular;
}
.add-coworkers-input-container .roles-dropdown {
  width: 100%;
}
.add-coworkers-input-container .invitation-message-textarea {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  padding: 10px;
}
.add-coworkers-input-container .invitation-message-textarea:focus-visible {
  border: 1px solid #424242;
  outline: none;
  box-shadow: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL3RtcC9idWlsZF9mNmVhODkyMC9hcHAvamF2YXNjcmlwdC9jb21wb25lbnRzL2NvbW1vbi9BZGRDb3dvcmtlcnNJbnB1dCIsInNvdXJjZXMiOlsiQWRkQ293b3JrZXJzSW5wdXQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHRTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBSUo7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIkB1c2UgXCIuLi8uLi8uLi8uLi9hc3NldHMvc3R5bGVzaGVldHMvY2xvcmEtYm9vdHN0cmFwLXZhcmlhYmxlc1wiIGFzIHZhcnM7XG5cbi5hZGQtY293b3JrZXJzLWlucHV0LWNvbnRhaW5lciB7XG4gIC5pbnZpdGF0aW9uLWxhYmVsIHtcbiAgICBmb250LWZhbWlseTogYXZlbmlybmV4dC1tZWRpdW07IFxuICAgIGZvbnQtc2l6ZTogMTZweDsgXG4gICAgZm9udC13ZWlnaHQ6IDUwMDsgXG4gICAgbGluZS1oZWlnaHQ6IDIycHg7IFxuXG4gICAgLmxpZ2h0ZXIge1xuICAgICAgZm9udC1mYW1pbHk6IGF2ZW5pcm5leHQtcmVndWxhcjtcbiAgICB9XG4gIH1cblxuICAucm9sZXMtZHJvcGRvd24ge1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG5cbiAgLmludml0YXRpb24tbWVzc2FnZS10ZXh0YXJlYSB7XG4gICAgYm9yZGVyOiAxcHggc29saWQgdmFycy4kbmV1dHJhbC1ncmF5LWRpc2FibGVkO1xuICAgIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgICBwYWRkaW5nOiAxMHB4O1xuXG4gICAgJjpmb2N1cy12aXNpYmxlIHtcbiAgICAgIGJvcmRlcjogMXB4IHNvbGlkIHZhcnMuJG5ldXRyYWwtZ3JheS1kYXJrO1xuICAgICAgb3V0bGluZTogbm9uZTsgXG4gICAgICBib3gtc2hhZG93OiBub25lOyBcbiAgICB9XG4gIH1cbn0iXX0= */